import { render, staticRenderFns } from "./DGImportForm.vue?vue&type=template&id=48d76e2b&"
import script from "./DGImportForm.vue?vue&type=script&lang=js&"
export * from "./DGImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports